module.exports = __webpack_public_path__ + "929b2451f083e5ee5eacc3988273c2a3.woff2";